import React from 'react';

export default function SplashScreen() {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#fff7e1',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      {/* Adjust width/height or objectFit as needed */}
      <img
        src={`/images/splash.png`}
        alt="App Splash"
        style={{ width: '20%', maxWidth: 400 }}
      />
    </div>
  );
}
